import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export interface AjustarPontuacaoItem {
  idItem: number;
  orderIdApp: string;
  numeroNf: string;
  cliente: string;
  dtFaturamentoErp: Date;
  produto: string;
  pontuacaoAGerar: number;
}

export interface AjustarPontuacaoResultado {
  itensAtualizados: number;
}

@Injectable({
  providedIn: 'root'
})
export class AjustarPontuacaoService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  getItens(dataDoFiltro: string): Observable<AjustarPontuacaoItem[]> {
    this.headers.set('Content-Type', 'application/json');

    return this.http.post<AjustarPontuacaoItem[]>(this.baseUrl + 'api/AjustarPontuacao/GetItens', this.criarRequest(dataDoFiltro), { headers: this.headers }).pipe(
      catchError(error => {
        this.toastr.error(error?.error || '', 'Houve um erro, contate o suporte...');
        return of([]);
      })
    );
  }

  ajustarNota(orderIdApp: string): Observable<AjustarPontuacaoResultado> {
    this.headers.set('Content-Type', 'application/json');

    return this.http.post<AjustarPontuacaoResultado>(this.baseUrl + 'api/AjustarPontuacao/AjustarNota', this.criarRequest(null, orderIdApp), { headers: this.headers }).pipe(
      catchError(error => {
        this.toastr.error(error?.error || '', 'Houve um erro, contate o suporte...');
        return of({ itensAtualizados: 0 });
      })
    );
  }

  ajustarTodas(dataDoFiltro: string): Observable<AjustarPontuacaoResultado> {
    this.headers.set('Content-Type', 'application/json');

    return this.http.post<AjustarPontuacaoResultado>(this.baseUrl + 'api/AjustarPontuacao/AjustarTodas', this.criarRequest(dataDoFiltro), { headers: this.headers }).pipe(
      catchError(error => {
        this.toastr.error(error?.error || '', 'Houve um erro, contate o suporte...');
        return of({ itensAtualizados: 0 });
      })
    );
  }

  private criarRequest(dataDoFiltro?: string, orderIdApp?: string) {
    return {
      userId: parseInt(localStorage.getItem('id')),
      dataDoFiltro: dataDoFiltro,
      orderIdApp: orderIdApp
    };
  }
}
